import * as React from 'react';
const SvgCloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 13.5a4.5 4.5 0 0 1-4.5 4.5H7a5 5 0 1 1 .337-9.989A6.003 6.003 0 0 1 18.952 9.24 4.5 4.5 0 0 1 22 13.5m-2 0a2.5 2.5 0 0 1-2.5 2.5H7a3 3 0 1 1 3-3h2a5 5 0 0 0-2.727-4.455 4.001 4.001 0 0 1 7.578 2.54 2.5 2.5 0 0 1 1.987.303A2.5 2.5 0 0 1 20 13.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloud;
